import { InputField } from '../../Input'
import { Container } from '../Container'

import { INPUT_FIELD_SIZES } from './InputFields.constants'

import * as styles from './InputFields.module.css'

import InfoIcon from '../../../icons/info.svg'

function InputFields() {
  return (
    <>
      <Container label='Input, outside label, sizes - 48px, 40px, 32px'>
        {INPUT_FIELD_SIZES.map(size => (
          <InputField
            height={size}
            key={size}
            label='Label'
            placeholder='Placeholder'
            wrapperClassName={styles.input}
          />
        ))}
      </Container>
      <Container label='Input, outside label, with value, sizes - 48px, 40px, 32px'>
        {INPUT_FIELD_SIZES.map(size => (
          <InputField
            height={size}
            key={size}
            label='Label'
            placeholder='Placeholder'
            value='Value'
            wrapperClassName={styles.input}
            onClear={() => {}}
          />
        ))}
      </Container>
      <Container label='Input, outside label, with counter, sizes - 48px, 40px, 32px'>
        {INPUT_FIELD_SIZES.map(size => (
          <InputField
            hasCounter
            height={size}
            key={size}
            label='Label'
            maxLength={256}
            placeholder='Placeholder'
            value=''
            wrapperClassName={styles.input}
            onClear={() => {}}
          />
        ))}
      </Container>
      <Container label='Input, outside label, with value, with counter, sizes - 48px, 40px, 32px'>
        {INPUT_FIELD_SIZES.map(size => (
          <InputField
            hasCounter
            height={size}
            key={size}
            label='Label'
            maxLength={256}
            placeholder='Placeholder'
            value='Value'
            wrapperClassName={styles.input}
            onClear={() => {}}
          />
        ))}
      </Container>
      <Container label='Input, outside label, with value, with counter, with help text, sizes - 48px, 40px, 32px'>
        {INPUT_FIELD_SIZES.map(size => (
          <InputField
            hasCounter
            height={size}
            helpText='Help text goes here'
            key={size}
            label='Label'
            maxLength={256}
            placeholder='Placeholder'
            value='Value'
            wrapperClassName={styles.input}
            onClear={() => {}}
          />
        ))}
      </Container>
      <Container label='Input, outside label, disabled, with value, with counter, with help text, sizes - 48px, 40px, 32px'>
        {INPUT_FIELD_SIZES.map(size => (
          <InputField
            disabled
            hasCounter
            height={size}
            helpText='Help text goes here'
            key={size}
            label='Label'
            maxLength={256}
            placeholder='Placeholder'
            value='Value'
            wrapperClassName={styles.input}
            onClear={() => {}}
          />
        ))}
      </Container>
      <Container label='Input, outside label, error, with value, with counter, sizes - 48px, 40px, 32px'>
        {INPUT_FIELD_SIZES.map(size => (
          <InputField
            hasCounter
            errorText='Error message replaces helper text'
            height={size}
            key={size}
            label='Label'
            maxLength={256}
            placeholder='Placeholder'
            wrapperClassName={styles.input}
            onClear={() => {}}
          />
        ))}
      </Container>

      <Container label='Input field, sizes - 48px, 40px, 32px'>
        {INPUT_FIELD_SIZES.map(size => (
          <InputField
            height={size}
            key={size}
            placeholder='Placeholder'
            wrapperClassName={styles.input}
          />
        ))}
      </Container>

      <Container label='Input field, with outside label, with text, with counter, with help, , sizes - 48px, 40px, 32px'>
        {INPUT_FIELD_SIZES.map(size => (
          <InputField
            hasCounter
            height={size}
            helpText='Help text goes here'
            key={size}
            label='Label'
            maxLength={256}
            placeholder='Placeholder'
            value='Value'
            wrapperClassName={styles.input}
            onClear={() => {}}
          />
        ))}
      </Container>
      <Container label='Input field, with outside label, with text, with counter, with help, with info, sizes - 48px, 40px, 32px'>
        {INPUT_FIELD_SIZES.map(size => (
          <InputField
            hasCounter
            afterIconProps={{ Icon: InfoIcon }}
            height={size}
            helpText='Help text goes here'
            key={size}
            label='Label'
            maxLength={256}
            placeholder='Placeholder'
            value='Value'
            wrapperClassName={styles.input}
            onClear={() => {}}
          />
        ))}
      </Container>
      <Container label='Input field, with outside label, with text, with counter, with help, disabled, sizes - 48px, 40px, 32px'>
        {INPUT_FIELD_SIZES.map(size => (
          <InputField
            disabled
            hasCounter
            height={size}
            helpText='Help text goes here'
            key={size}
            label='Label'
            maxLength={256}
            placeholder='Placeholder'
            value='Value'
            wrapperClassName={styles.input}
            onClear={() => {}}
          />
        ))}
      </Container>
      <Container label='Input field, with outside label, with error, sizes - 48px, 40px, 32px'>
        {INPUT_FIELD_SIZES.map(size => (
          <InputField
            hasCounter
            errorText='Error message replaces helper text'
            height={size}
            key={size}
            label='Label'
            maxLength={256}
            placeholder='Placeholder'
            wrapperClassName={styles.input}
            onClear={() => {}}
          />
        ))}
      </Container>
      <Container label='Input field, with outside label, with text, with counter, with error, sizes - 48px, 40px, 32px'>
        {INPUT_FIELD_SIZES.map(size => (
          <InputField
            hasCounter
            errorText='Error message replaces helper text'
            height={size}
            key={size}
            label='Label'
            maxLength={256}
            placeholder='Placeholder'
            value='Value'
            wrapperClassName={styles.input}
            onClear={() => {}}
          />
        ))}
      </Container>
      <Container label='Input field, with text, with counter, with error, inline, sizes - 48px, 40px, 32px'>
        {INPUT_FIELD_SIZES.map(size => (
          <InputField
            hasCounter
            inline
            errorText='Error message replaces helper text'
            height={size}
            key={size}
            maxLength={256}
            placeholder='Placeholder'
            value='Value'
            wrapperClassName={styles.input}
            onClear={() => {}}
          />
        ))}
      </Container>
      <Container label='Input field, borderless, sizes - 48px, 40px, 32px'>
        {INPUT_FIELD_SIZES.map(size => (
          <InputField
            borderless
            height={size}
            key={size}
            placeholder='Placeholder'
            wrapperClassName={styles.input}
            onClear={() => {}}
          />
        ))}
      </Container>
      <Container label='Input field, with text, with counter, borderless, sizes - 48px, 40px, 32px'>
        {INPUT_FIELD_SIZES.map(size => (
          <InputField
            borderless
            hasCounter
            height={size}
            key={size}
            maxLength={256}
            placeholder='Placeholder'
            value='Value'
            wrapperClassName={styles.input}
            onClear={() => {}}
          />
        ))}
      </Container>
      <Container label='Input field, with text, with counter, with help, borderless, sizes - 48px, 40px, 32px'>
        {INPUT_FIELD_SIZES.map(size => (
          <InputField
            borderless
            hasCounter
            height={size}
            helpText='Help text goes here'
            key={size}
            maxLength={256}
            placeholder='Placeholder'
            value='Value'
            wrapperClassName={styles.input}
            onClear={() => {}}
          />
        ))}
      </Container>
      <Container label='Input field, with text, with counter, borderless, disabled, sizes - 48px, 40px, 32px'>
        {INPUT_FIELD_SIZES.map(size => (
          <InputField
            borderless
            disabled
            hasCounter
            height={size}
            key={size}
            maxLength={256}
            placeholder='Placeholder'
            value='Value'
            wrapperClassName={styles.input}
            onClear={() => {}}
          />
        ))}
      </Container>
      <Container label='Input field, with text, with counter, with error, borderless, sizes - 48px, 40px, 32px'>
        {INPUT_FIELD_SIZES.map(size => (
          <InputField
            borderless
            hasCounter
            errorText='Error message replaces helper text'
            height={size}
            key={size}
            maxLength={256}
            placeholder='Placeholder'
            value='Value'
            wrapperClassName={styles.input}
            onClear={() => {}}
          />
        ))}
      </Container>
    </>
  )
}

export default InputFields
